import axios from 'axios'
import { client } from './axios'
import { STORAGE_KEYS } from '../constants/storageKeys'
import { useTenantStore } from '../store/tenentStore'

export const MetricsEvent = {
  DATA_ROOM_FILE_UPLOADED: 'DATA_ROOM_FILE_UPLOADED',
  USER_LOGOUT: 'USER_LOGOUT',
  LIMIT_HIT: 'LIMIT_HIT',
} as const

export type MetricsEvent = (typeof MetricsEvent)[keyof typeof MetricsEvent]

// Limit types blocked client-side (no request reaches the backend).
export type FeLimitType = 'MEMBER_COUNT' | 'WHITE_LABEL' | 'LAYER_EXPORT'

const getToken = () =>
  localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) || sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)

const getTenantId = (): string | undefined => useTenantStore.getState().currentTenant?.id

export const logMetricsEvent = (eventType: MetricsEvent, metadata?: Record<string, unknown>): void => {
  const tenantId = getTenantId()
  client
    .post('/metrics/log-event', { eventType, ...(tenantId && { tenantId }), metadata })
    .catch(() => undefined)
}

export const logLimitHit = (
  limitType: FeLimitType,
  details?: { plan?: string; attemptedValue?: number; limitValue?: number | null },
): void => {
  logMetricsEvent(MetricsEvent.LIMIT_HIT, {
    limitType,
    ...(details?.plan != null && { plan: details.plan }),
    ...(details?.attemptedValue != null && { attemptedValue: details.attemptedValue }),
    ...(details?.limitValue != null && { limitValue: details.limitValue }),
  })
}

// Logout-safe variant (bypassing the refresh interceptor)
export const logMetricsEventOnLogout = (): void => {
  const token = getToken()
  if (!token) return
  // Read before the logout flow clears the store.
  const tenantId = getTenantId()
  const baseURL = `${import.meta.env.VITE_APP_API_URL}/`
  axios
    .post(
      '/metrics/log-event',
      { eventType: MetricsEvent.USER_LOGOUT, ...(tenantId && { tenantId }) },
      { baseURL, headers: { Authorization: `Bearer ${token}` } },
    )
    .catch(() => undefined)
}
